const salesPSMock ={
    "title": "Sales",
    "type": "Sales",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 233.0,
                                                "percent": 1.0
                                            },
                                            "compare": {
                                                "value": 231.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 246.0,
                                                "percent": -4.0
                                            },
                                            "compare": {
                                                "value": 256.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 286.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 307.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 322.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 232.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 273.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 193.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 239.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -10.0,
                                                "columns": [
                                                    112.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 1.0,
                                                "columns": [
                                                    134.0,
                                                    132.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    153.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    163.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    108.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    126.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 89.0,
                                                "percent": 7.0
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 112.0,
                                                "percent": -10.0
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 153.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 158.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 122.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -10.0,
                                                "columns": [
                                                    112.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 1.0,
                                                "columns": [
                                                    134.0,
                                                    132.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    153.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    163.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    108.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    126.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 143.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 147.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 134.0,
                                                "percent": 1.0
                                            },
                                            "compare": {
                                                "value": 132.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 158.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 161.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 168.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 163.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 152.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 152.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 151.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 141.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 126.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -10.0,
                                                "columns": [
                                                    112.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 1.0,
                                                "columns": [
                                                    134.0,
                                                    132.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    153.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    163.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    108.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    126.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 49.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -10.0,
                                                "columns": [
                                                    112.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 1.0,
                                                "columns": [
                                                    134.0,
                                                    132.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    153.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    163.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    108.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    126.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": -10.0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 72.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 98.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 90.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 88.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -10.0,
                                                "columns": [
                                                    112.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 1.0,
                                                "columns": [
                                                    134.0,
                                                    132.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    153.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    163.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    108.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    126.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -5.0
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": -16.0
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -10.0,
                                                "columns": [
                                                    112.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 1.0,
                                                "columns": [
                                                    134.0,
                                                    132.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    153.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    168.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    158.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    163.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    108.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    151.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    113.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    126.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 233.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 231.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 246.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 256.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 286.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 307.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 322.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 232.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 273.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 193.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 239.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -21.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 14.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 25.0,
                                                "columns": [
                                                    112.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -7.0,
                                                "columns": [
                                                    134.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -21.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 14.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 25.0,
                                                "columns": [
                                                    112.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -7.0,
                                                "columns": [
                                                    134.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 143.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 126.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 143.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -21.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 14.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 25.0,
                                                "columns": [
                                                    112.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -7.0,
                                                "columns": [
                                                    134.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -21.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 14.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 25.0,
                                                "columns": [
                                                    112.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -7.0,
                                                "columns": [
                                                    134.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 98.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 90.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 88.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -21.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 14.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 25.0,
                                                "columns": [
                                                    112.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -7.0,
                                                "columns": [
                                                    134.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -21.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 14.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 25.0,
                                                "columns": [
                                                    112.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -7.0,
                                                "columns": [
                                                    134.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 233.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 231.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 246.0,
                                                "percent": 9.0
                                            },
                                            "compare": {
                                                "value": 256.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 286.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 307.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 322.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 232.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 273.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 195.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 193.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 239.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    112.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -6.0,
                                                "columns": [
                                                    134.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    65.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    63.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 89.0,
                                                "percent": 10.0
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 112.0,
                                                "percent": 36.0
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 153.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 158.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 122.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    112.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -6.0,
                                                "columns": [
                                                    134.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    65.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    63.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 143.0,
                                                "percent": 0.0
                                            },
                                            "compare": {
                                                "value": 147.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 134.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 132.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 158.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 161.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 168.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 163.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 152.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 152.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 151.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 141.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 126.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    112.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -6.0,
                                                "columns": [
                                                    134.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    65.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    63.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 49.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 48.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    112.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -6.0,
                                                "columns": [
                                                    134.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    65.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    63.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 72.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 98.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 90.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 88.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 69.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    112.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -6.0,
                                                "columns": [
                                                    134.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    65.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    63.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    112.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -6.0,
                                                "columns": [
                                                    134.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    144.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    145.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    65.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    63.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    139.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 479.0,
                                                "percent": -2.0
                                            },
                                            "compare": {
                                                "value": 487.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 798.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 915.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 766.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 627.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    422.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    493.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    310.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    455.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    224.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    403.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 201.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 361.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 422.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 310.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    422.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    493.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    310.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    455.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    224.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    403.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 278.0,
                                                "percent": -1.0
                                            },
                                            "compare": {
                                                "value": 279.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 437.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 493.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 455.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 403.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    422.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    493.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    310.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    455.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    224.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    403.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 138.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 146.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 145.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    422.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    493.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    310.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    455.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    224.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    403.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": -8.0
                                            },
                                            "compare": {
                                                "value": 171.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 269.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 304.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 267.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 220.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    422.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    493.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    310.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    455.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    224.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    403.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": -11.0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    422.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    493.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    310.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    455.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    224.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    403.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 479.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 487.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 798.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 915.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 766.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 627.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 81.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 201.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 111.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 81.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 278.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 278.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 403.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 81.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 145.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 138.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 146.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 145.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 81.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 171.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 148.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 269.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 220.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 304.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 267.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 220.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 81.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 81.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 479.0,
                                                "percent": 7.0
                                            },
                                            "compare": {
                                                "value": 487.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 798.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 915.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 766.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 627.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    431.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    192.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 201.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 361.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 422.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 310.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    431.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    192.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 278.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 279.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 437.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 493.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 455.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 403.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    431.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    192.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 138.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 146.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 145.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    431.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    192.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 171.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 269.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 304.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 267.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 220.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    431.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    192.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 51.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    431.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    235.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    435.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    192.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 233.0,
                                                "percent": 1.0
                                            },
                                            "compare": {
                                                "value": 231.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 479.0,
                                                "percent": -2.0
                                            },
                                            "compare": {
                                                "value": 487.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 798.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1084.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1392.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1713.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1946.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2206.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2479.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2674.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2867.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3106.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    486.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    598.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    625.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    767.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    783.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    930.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    863.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1082.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    972.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1234.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1094.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1385.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1148.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1526.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1204.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1663.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1318.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1788.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 89.0,
                                                "percent": 7.0
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 201.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 361.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 486.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 625.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 783.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 863.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 972.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1094.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1148.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1204.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1318.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    486.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    598.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    625.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    767.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    783.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    930.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    863.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1082.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    972.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1234.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1094.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1385.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1148.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1526.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1204.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1663.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1318.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1788.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 143.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 147.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 278.0,
                                                "percent": -1.0
                                            },
                                            "compare": {
                                                "value": 279.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 437.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 598.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 767.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 930.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1082.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1385.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1526.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1663.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1788.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    486.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    598.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    625.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    767.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    783.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    930.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    863.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1082.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    972.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1234.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1094.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1385.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1148.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1526.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1204.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1663.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1318.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1788.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": 19.0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 214.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 262.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 359.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 408.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 459.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 509.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 553.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    486.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    598.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    625.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    767.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    783.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    930.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    863.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1082.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    972.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1234.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1094.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1385.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1148.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1526.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1204.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1663.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1318.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1788.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": -10.0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": -8.0
                                            },
                                            "compare": {
                                                "value": 171.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 269.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 371.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 474.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 573.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 663.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 752.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 840.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 919.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 987.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1060.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    486.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    598.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    625.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    767.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    783.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    930.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    863.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1082.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    972.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1234.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1094.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1385.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1148.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1526.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1204.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1663.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1318.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1788.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -5.0
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": -11.0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 95.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 123.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 175.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 7.0,
                                                "columns": [
                                                    89.0,
                                                    84.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    143.0,
                                                    147.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -3.0,
                                                "columns": [
                                                    201.0,
                                                    208.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -1.0,
                                                "columns": [
                                                    278.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    437.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    486.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    598.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    625.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    767.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    783.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    930.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    863.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1082.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    972.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1234.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1094.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1385.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1148.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1526.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1204.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1663.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1318.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1788.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 233.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 231.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 479.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 487.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 798.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1084.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1392.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1713.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1946.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2206.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2479.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2674.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2867.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3106.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1318.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 201.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 201.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 143.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1788.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 278.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 143.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 278.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 553.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 214.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 262.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 359.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 408.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 459.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 509.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 553.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1060.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 171.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 269.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 157.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 371.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 474.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 573.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 663.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 752.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 840.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 919.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 987.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1060.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 175.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 95.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 123.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 175.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    89.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    201.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    278.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 233.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 231.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 479.0,
                                                "percent": 7.0
                                            },
                                            "compare": {
                                                "value": 487.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 798.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1084.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1392.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1713.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1946.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2206.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2479.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2674.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2867.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3106.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    325.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    573.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    407.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    716.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    488.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    860.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    566.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1005.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    645.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1150.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1295.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    787.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1433.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    852.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1571.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    915.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1710.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 89.0,
                                                "percent": 10.0
                                            },
                                            "compare": {
                                                "value": 84.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 201.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 208.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 361.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 486.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 625.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 783.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 863.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 972.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1094.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1148.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1204.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1318.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    325.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    573.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    407.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    716.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    488.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    860.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    566.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1005.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    645.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1150.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1295.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    787.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1433.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    852.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1571.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    915.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1710.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 143.0,
                                                "percent": 0.0
                                            },
                                            "compare": {
                                                "value": 147.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 278.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 279.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 437.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 598.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 767.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 930.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1082.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1385.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1526.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1663.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1788.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    325.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    573.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    407.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    716.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    488.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    860.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    566.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1005.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    645.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1150.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1295.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    787.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1433.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    852.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1571.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    915.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1710.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 46.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 96.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 124.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 167.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 214.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 262.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 311.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 359.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 408.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 459.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 509.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 553.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    325.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    573.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    407.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    716.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    488.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    860.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    566.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1005.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    645.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1150.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1295.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    787.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1433.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    852.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1571.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    915.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1710.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 84.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 157.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 171.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 269.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 371.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 474.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 573.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 663.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 752.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 840.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 919.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 987.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1060.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    325.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    573.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    407.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    716.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    488.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    860.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    566.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1005.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    645.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1150.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1295.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    787.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1433.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    852.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1571.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    915.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1710.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 44.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 95.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 108.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 123.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 166.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 175.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 10.0,
                                                "columns": [
                                                    89.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    143.0,
                                                    143.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 23.0,
                                                "columns": [
                                                    201.0,
                                                    163.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -3.0,
                                                "columns": [
                                                    278.0,
                                                    286.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    244.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    429.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    325.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    573.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    407.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    716.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    488.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    860.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    566.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1005.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    645.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1150.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1295.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    787.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1433.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    852.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1571.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    915.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1710.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ]
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Potash',
        },
        {
          // NavigationItem
          title: 'Sdom',
        },
        {
          // NavigationItem
          title: 'IBP',
        },
      ],
};

const ebitdaPSMock = {
    "title": "EBITDA",
    "type": "EBITDA",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 55.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 52.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 109.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 92.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 115.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 88.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 76.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -23.0,
                                                "columns": [
                                                    27.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -23.0,
                                                "columns": [
                                                    25.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": -14.0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 66.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 11.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -23.0,
                                                "columns": [
                                                    27.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -23.0,
                                                "columns": [
                                                    25.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 28.0,
                                                "percent": -30.0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -23.0,
                                                "columns": [
                                                    27.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -23.0,
                                                "columns": [
                                                    25.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": 2.0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -23.0,
                                                "columns": [
                                                    27.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -23.0,
                                                "columns": [
                                                    25.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -23.0,
                                                "columns": [
                                                    27.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -23.0,
                                                "columns": [
                                                    25.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": -113.0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": -312.0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -23.0,
                                                "columns": [
                                                    27.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -23.0,
                                                "columns": [
                                                    25.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 109.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 92.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 115.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 88.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 76.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -50.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 28.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -1.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -50.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 28.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -1.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -50.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 28.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -1.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -50.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 28.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -1.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -50.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 28.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -1.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -50.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 28.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -1.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 55.0,
                                                "percent": 25.0
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 52.0,
                                                "percent": 21.0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 109.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 92.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 115.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 88.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 76.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 42.0,
                                                "columns": [
                                                    27.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 5.0,
                                                "columns": [
                                                    25.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    14.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": 36.0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": 42.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 66.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 11.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 42.0,
                                                "columns": [
                                                    27.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 5.0,
                                                "columns": [
                                                    25.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    14.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 28.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 42.0,
                                                "columns": [
                                                    27.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 5.0,
                                                "columns": [
                                                    25.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    14.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 42.0,
                                                "columns": [
                                                    27.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 5.0,
                                                "columns": [
                                                    25.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    14.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 42.0,
                                                "columns": [
                                                    27.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 5.0,
                                                "columns": [
                                                    25.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    14.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 42.0,
                                                "columns": [
                                                    27.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 5.0,
                                                "columns": [
                                                    25.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    14.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    15.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 315.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 239.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    183.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    85.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 54.0,
                                                "percent": -19.0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 133.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 129.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 85.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    183.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    85.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 53.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 115.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 110.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    183.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    85.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": -14.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    183.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    85.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": -25.0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    183.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    85.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": -180.0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    183.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    129.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    85.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 315.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 239.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 79.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 85.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 79.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 58.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 79.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 79.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 46.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 79.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 79.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -9.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 315.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 239.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 54.0,
                                                "percent": 39.0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 133.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 129.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 85.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 53.0,
                                                "percent": 10.0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 115.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 110.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 16.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 113.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    74.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 55.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": -23.0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 340.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 447.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 562.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 649.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 723.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 801.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 853.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 890.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 966.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    179.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    243.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    204.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    316.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    358.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    319.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    445.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    357.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    464.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    389.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    475.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    436.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": -14.0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 54.0,
                                                "percent": -19.0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 133.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 179.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 243.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 316.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 358.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 404.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 445.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 464.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 475.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 529.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    179.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    243.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    204.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    316.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    358.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    319.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    445.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    357.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    464.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    389.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    475.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    436.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 28.0,
                                                "percent": -30.0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 53.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 115.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 161.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 204.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 246.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 291.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 319.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 357.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 389.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 415.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 436.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    179.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    243.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    204.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    316.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    358.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    319.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    445.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    357.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    464.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    389.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    475.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    436.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": -14.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 65.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    179.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    243.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    204.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    316.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    358.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    319.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    445.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    357.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    464.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    389.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    475.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    436.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": -25.0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 173.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 246.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 266.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 298.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 326.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 344.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 370.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    179.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    243.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    204.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    316.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    358.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    319.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    445.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    357.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    464.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    389.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    475.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    436.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": -113.0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": -180.0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -14.0,
                                                "columns": [
                                                    27.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -30.0,
                                                "columns": [
                                                    28.0,
                                                    40.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -19.0,
                                                "columns": [
                                                    54.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    53.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    179.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    243.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    204.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    316.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    246.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    358.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    404.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    319.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    445.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    357.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    464.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    389.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    475.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    415.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    529.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    436.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 340.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 447.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 562.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 649.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 723.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 801.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 853.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 890.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 966.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 529.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 436.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 65.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 370.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 45.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 173.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 246.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 266.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 298.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 326.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 344.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 370.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": -1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    27.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    28.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    53.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0.0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 55.0,
                                                "percent": 25.0
                                            },
                                            "compare": {
                                                "value": 71.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": 23.0
                                            },
                                            "compare": {
                                                "value": 139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 247.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 340.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 447.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 562.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 649.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 723.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 801.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 853.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 890.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 966.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    123.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    148.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    175.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    202.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    228.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    253.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    201.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    302.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 27.0,
                                                "percent": 36.0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 54.0,
                                                "percent": 39.0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 133.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 179.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 243.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 316.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 358.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 404.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 445.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 464.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 475.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 529.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    123.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    148.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    175.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    202.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    228.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    253.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    201.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    302.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 28.0,
                                                "percent": 16.0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 53.0,
                                                "percent": 10.0
                                            },
                                            "compare": {
                                                "value": 72.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 115.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 161.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 204.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 246.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 291.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 319.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 357.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 389.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 415.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 436.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    123.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    148.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    175.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    202.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    228.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    253.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    201.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    302.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "FOOD",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 3.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 65.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    123.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    148.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    175.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    202.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    228.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    253.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    201.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    302.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AA",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 25.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 45.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 96.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 137.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 173.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 209.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 246.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 266.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 298.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 326.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 344.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 370.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    123.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    148.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    175.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    202.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    228.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    253.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    201.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    302.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "PROL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -1.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 36.0,
                                                "columns": [
                                                    27.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 16.0,
                                                "columns": [
                                                    28.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 39.0,
                                                "columns": [
                                                    54.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 10.0,
                                                "columns": [
                                                    53.0,
                                                    48.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    97.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    123.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    148.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    175.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    202.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    172.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    228.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    186.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    253.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    201.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    302.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ]
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Potash',
        },
        {
          // NavigationItem
          title: 'Sdom',
        },
        {
          // NavigationItem
          title: 'IBP',
        },
      ],
};

const oiPSMock = {
    "title": "OI",
    "type": "OI",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 37.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -36.0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 93.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 78.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 91.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 99.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 73.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "COM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 14.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 13.0,
                                                "percent": -47.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 36.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SPE",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": -33.0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 21.0,
                                                "percent": -27.0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 38.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 37.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -27.0,
                                                "columns": [
                                                    14.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -33.0,
                                                "columns": [
                                                    23.0,
                                                    35.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": -47.0,
                                                "columns": [
                                                    13.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": -27.0,
                                                "columns": [
                                                    21.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    9.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "COM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SPE",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                        ],
                        "isMainGraph": false
                    }
                }
            ]
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'COM',
        },
        {
          // NavigationItem
          title: 'SPE',
        },
      ],
};

const potashDivisionMock = {
  "type": "PRODUCTION_DIVISION",
  "title": "Production (KMT)",
  "subMenu": [
    {
      "data": [
        {
          "data": {
            "cols": [
              {
                "date": "01/11",
                "value": 177,
                "colName": "01",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "02/11",
                "value": 199,
                "colName": "02",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "03/11",
                "value": 181,
                "colName": "03",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "04/11",
                "value": 162,
                "colName": "04",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "05/11",
                "value": 179,
                "colName": "05",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "06/11",
                "value": 187,
                "colName": "06",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "07/11",
                "value": 68,
                "colName": "07",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "08/11",
                "value": 198,
                "colName": "08",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "09/11",
                "value": 175,
                "colName": "09",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "10/11",
                "value": 182,
                "colName": "10",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "11/11",
                "value": 186,
                "colName": "11",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "12/11",
                "value": 226,
                "colName": "12",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "13/11",
                "value": 162,
                "colName": "13",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "14/11",
                "value": 164,
                "colName": "14",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "15/11",
                "value": 172,
                "colName": "15",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "16/11",
                "value": 130,
                "colName": "16",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "17/11",
                "value": 152,
                "colName": "17",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "18/11",
                "value": 140,
                "colName": "18",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "19/11",
                "value": 0,
                "colName": "19",
                "colGroupName": "Nov 2023"
              }
            ],
            "addUp": 3041,
            "budget": 7090,
            "yAxisTitle": "BGT",
            "averageValue": 236
          },
          "title": ""
        }
      ],
      "title": "MKP",
      "subtitle": "Rotem"
    },
    {
      "data": [
        {
          "data": {
            "cols": [
              {
                "date": "01/11",
                "value": 24,
                "colName": "01",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "02/11",
                "value": 30,
                "colName": "02",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "03/11",
                "value": 32,
                "colName": "03",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "04/11",
                "value": 30,
                "colName": "04",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "05/11",
                "value": 32,
                "colName": "05",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "06/11",
                "value": 32,
                "colName": "06",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "07/11",
                "value": 32,
                "colName": "07",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "08/11",
                "value": 28,
                "colName": "08",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "09/11",
                "value": 28,
                "colName": "09",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "10/11",
                "value": 16,
                "colName": "10",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "11/11",
                "value": 26,
                "colName": "11",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "12/11",
                "value": 32,
                "colName": "12",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "13/11",
                "value": 98,
                "colName": "13",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "14/11",
                "value": 60,
                "colName": "14",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "15/11",
                "value": 43,
                "colName": "15",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "16/11",
                "value": 24,
                "colName": "16",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "17/11",
                "value": 30,
                "colName": "17",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "18/11",
                "value": 32,
                "colName": "18",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "19/11",
                "value": 55,
                "colName": "19",
                "colGroupName": "Nov 2023"
              }
            ],
            "addUp": 684,
            "budget": 1315,
            "yAxisTitle": "BGT",
            "averageValue": 44
          },
          "title": ""
        }
      ],
      "title": "Pek. & HiP & Other",
      "subtitle": "Rotem"
    },
    {
      "data": [
        {
          "data": {
            "cols": [],
            "addUp": 0,
            "budget": 0,
            "yAxisTitle": "Error",
            "averageValue": 0
          },
          "title": ""
        }
      ],
      "title": "MAP",
      "subtitle": "Rotem"
    },
    {
      "data": [
        {
          "data": {
            "cols": [
              {
                "date": "01/11",
                "value": 2989,
                "colName": "01",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "02/11",
                "value": 1743,
                "colName": "02",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "03/11",
                "value": 3407,
                "colName": "03",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "04/11",
                "value": 2345,
                "colName": "04",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "05/11",
                "value": 2364,
                "colName": "05",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "06/11",
                "value": 2714,
                "colName": "06",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "07/11",
                "value": 3256,
                "colName": "07",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "08/11",
                "value": 1116,
                "colName": "08",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "09/11",
                "value": 2203,
                "colName": "09",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "10/11",
                "value": 3539,
                "colName": "10",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "11/11",
                "value": 3088,
                "colName": "11",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "12/11",
                "value": 3119,
                "colName": "12",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "13/11",
                "value": 2834,
                "colName": "13",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "14/11",
                "value": 3291,
                "colName": "14",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "15/11",
                "value": 3361,
                "colName": "15",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "16/11",
                "value": 2060,
                "colName": "16",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "17/11",
                "value": 3266,
                "colName": "17",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "18/11",
                "value": 2552,
                "colName": "18",
                "colGroupName": "Nov 2023"
              }
            ],
            "addUp": 49247,
            "budget": 83000,
            "yAxisTitle": "BGT",
            "averageValue": 2767
          },
          "title": ""
        }
      ],
      "title": "Polysulphate",
      "subtitle": "Boulby"
    },
    {
      "data": [
        {
          "data": {
            "cols": [
              {
                "date": "01/11",
                "value": 890,
                "colName": "01",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "02/11",
                "value": 958,
                "colName": "02",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "03/11",
                "value": 988,
                "colName": "03",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "04/11",
                "value": 988,
                "colName": "04",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "05/11",
                "value": 576,
                "colName": "05",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "06/11",
                "value": 0,
                "colName": "06",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "07/11",
                "value": 0,
                "colName": "07",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "08/11",
                "value": 0,
                "colName": "08",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "09/11",
                "value": 0,
                "colName": "09",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "10/11",
                "value": 0,
                "colName": "10",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "11/11",
                "value": 0,
                "colName": "11",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "12/11",
                "value": 0,
                "colName": "12",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "13/11",
                "value": 0,
                "colName": "13",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "14/11",
                "value": 0,
                "colName": "14",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "15/11",
                "value": 456,
                "colName": "15",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "16/11",
                "value": 597,
                "colName": "16",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "17/11",
                "value": 833,
                "colName": "17",
                "colGroupName": "Nov 2023"
              },
              {
                "date": "18/11",
                "value": 766,
                "colName": "18",
                "colGroupName": "Nov 2023"
              }
            ],
            "addUp": 7051,
            "budget": 20412,
            "yAxisTitle": "BGT",
            "averageValue": 680
          },
          "title": ""
        }
      ],
      "title": "Potash Plus",
      "subtitle": "Boulby"
    },
    {
      "data": [
        {
          "data": {
            "cols": [],
            "addUp": 0,
            "budget": 0,
            "yAxisTitle": "Error",
            "averageValue": 0
          },
          "title": ""
        }
      ],
      "title": "Amfert",
      "subtitle": "Amfert"
    }
  ],
  "navigation": {
    "nav": {
      "qtd": [
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 23,
                            "percent": null
                          },
                          "current": {
                            "value": 10,
                            "percent": -32
                          },
                          "partial": {
                            "value": 15,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 22,
                            "percent": null
                          },
                          "current": {
                            "value": 9,
                            "percent": -41
                          },
                          "partial": {
                            "value": 15,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 16,
                            "percent": null
                          },
                          "current": {
                            "value": 12,
                            "percent": 4
                          },
                          "partial": {
                            "value": 11,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 14,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 8,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 39
                          },
                          "partial": {
                            "value": 1,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 29
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": -6
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 14
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": {
                            "value": 0,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 238,
                            "percent": null
                          },
                          "current": {
                            "value": 170,
                            "percent": 7
                          },
                          "partial": {
                            "value": 159,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 246,
                            "percent": null
                          },
                          "current": {
                            "value": 179,
                            "percent": 11
                          },
                          "partial": {
                            "value": 161,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 216,
                            "percent": null
                          },
                          "current": {
                            "value": 156,
                            "percent": 8
                          },
                          "partial": {
                            "value": 144,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 252,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 168,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 57,
                            "percent": null
                          },
                          "current": {
                            "value": 36,
                            "percent": -2
                          },
                          "partial": {
                            "value": 37,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 41,
                            "percent": 999
                          },
                          "partial": {
                            "value": 0,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": 999
                          },
                          "partial": {
                            "value": 0,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 111,
                            "percent": null
                          },
                          "current": {
                            "value": 96,
                            "percent": 27
                          },
                          "partial": {
                            "value": 76,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 121,
                            "percent": null
                          },
                          "current": {
                            "value": 94,
                            "percent": 27
                          },
                          "partial": {
                            "value": 75,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 153,
                            "percent": null
                          },
                          "current": {
                            "value": 105,
                            "percent": 1
                          },
                          "partial": {
                            "value": 103,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 133,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 88,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 10,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 9,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 12,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 170,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 179,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 156,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 36,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 41,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 96,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 94,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": 105,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": null,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 10,
                            "percent": -28
                          },
                          "partial": {
                            "value": 14,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 22,
                            "percent": null
                          },
                          "current": {
                            "value": 9,
                            "percent": -41
                          },
                          "partial": {
                            "value": 15,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 12,
                            "percent": -15
                          },
                          "partial": {
                            "value": 14,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 19,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 12,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": -23
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 45
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 19
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 2,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 999
                          },
                          "partial": {
                            "value": 0,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": {
                            "value": 0,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": {
                            "value": 3,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 3,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 256,
                            "percent": null
                          },
                          "current": {
                            "value": 170,
                            "percent": -1
                          },
                          "partial": {
                            "value": 171,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 261,
                            "percent": null
                          },
                          "current": {
                            "value": 179,
                            "percent": 4
                          },
                          "partial": {
                            "value": 172,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 242,
                            "percent": null
                          },
                          "current": {
                            "value": 156,
                            "percent": -3
                          },
                          "partial": {
                            "value": 161,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 251,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 167,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 59,
                            "percent": null
                          },
                          "current": {
                            "value": 36,
                            "percent": -6
                          },
                          "partial": {
                            "value": 38,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 41,
                            "percent": 999
                          },
                          "partial": {
                            "value": 0,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": 999
                          },
                          "partial": {
                            "value": 0,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q1",
                          "compare": {
                            "value": 168,
                            "percent": null
                          },
                          "current": {
                            "value": 96,
                            "percent": -13
                          },
                          "partial": {
                            "value": 110,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q2",
                          "compare": {
                            "value": 167,
                            "percent": null
                          },
                          "current": {
                            "value": 94,
                            "percent": -14
                          },
                          "partial": {
                            "value": 110,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q3",
                          "compare": {
                            "value": 175,
                            "percent": null
                          },
                          "current": {
                            "value": 105,
                            "percent": -12
                          },
                          "partial": {
                            "value": 119,
                            "percent": null
                          },
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": "Q4",
                          "compare": {
                            "value": 136,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": {
                            "value": 98,
                            "percent": null
                          },
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": "BGT"
        }
      ],
      "ytd": [
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -40
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 15,
                            "percent": null
                          },
                          "current": {
                            "value": 10,
                            "percent": -32
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 23,
                            "percent": null
                          },
                          "current": {
                            "value": 14,
                            "percent": -38
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 31,
                            "percent": null
                          },
                          "current": {
                            "value": 19,
                            "percent": -39
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 38,
                            "percent": null
                          },
                          "current": {
                            "value": 23,
                            "percent": -39
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 45,
                            "percent": null
                          },
                          "current": {
                            "value": 29,
                            "percent": -36
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 50,
                            "percent": null
                          },
                          "current": {
                            "value": 34,
                            "percent": -31
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 56,
                            "percent": null
                          },
                          "current": {
                            "value": 40,
                            "percent": -28
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 61,
                            "percent": null
                          },
                          "current": {
                            "value": 46,
                            "percent": -25
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 66,
                            "percent": null
                          },
                          "current": {
                            "value": 52,
                            "percent": -21
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 69,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 75,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 13
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 39
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 23
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": 19
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": 26
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": 13
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 7,
                            "percent": 12
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 8,
                            "percent": 7
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 9,
                            "percent": null
                          },
                          "current": {
                            "value": 9,
                            "percent": 7
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 10,
                            "percent": null
                          },
                          "current": {
                            "value": 10,
                            "percent": 1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 11,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 12,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 14
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 14
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 69
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 69
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 47
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": -18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": -18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -23
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -40
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 9,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 79,
                            "percent": null
                          },
                          "current": {
                            "value": 87,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 159,
                            "percent": null
                          },
                          "current": {
                            "value": 170,
                            "percent": 7
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 238,
                            "percent": null
                          },
                          "current": {
                            "value": 263,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 320,
                            "percent": null
                          },
                          "current": {
                            "value": 347,
                            "percent": 8
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 399,
                            "percent": null
                          },
                          "current": {
                            "value": 442,
                            "percent": 11
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 484,
                            "percent": null
                          },
                          "current": {
                            "value": 527,
                            "percent": 9
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 556,
                            "percent": null
                          },
                          "current": {
                            "value": 594,
                            "percent": 7
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 628,
                            "percent": null
                          },
                          "current": {
                            "value": 683,
                            "percent": 9
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 700,
                            "percent": null
                          },
                          "current": {
                            "value": 772,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 784,
                            "percent": null
                          },
                          "current": {
                            "value": 821,
                            "percent": 5
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 868,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 952,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 16,
                            "percent": null
                          },
                          "current": {
                            "value": 20,
                            "percent": 24
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 37,
                            "percent": null
                          },
                          "current": {
                            "value": 36,
                            "percent": -2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 57,
                            "percent": null
                          },
                          "current": {
                            "value": 44,
                            "percent": -23
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 75,
                            "percent": null
                          },
                          "current": {
                            "value": 65,
                            "percent": -14
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 95,
                            "percent": null
                          },
                          "current": {
                            "value": 85,
                            "percent": -11
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 112,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": -20
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 130,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": -31
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 150,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": -40
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 157,
                            "percent": null
                          },
                          "current": {
                            "value": 98,
                            "percent": -37
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 173,
                            "percent": null
                          },
                          "current": {
                            "value": 106,
                            "percent": -39
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 192,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 204,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 40,
                            "percent": null
                          },
                          "current": {
                            "value": 47,
                            "percent": 18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 76,
                            "percent": null
                          },
                          "current": {
                            "value": 96,
                            "percent": 27
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 111,
                            "percent": null
                          },
                          "current": {
                            "value": 142,
                            "percent": 28
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 142,
                            "percent": null
                          },
                          "current": {
                            "value": 187,
                            "percent": 32
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 185,
                            "percent": null
                          },
                          "current": {
                            "value": 236,
                            "percent": 28
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 231,
                            "percent": null
                          },
                          "current": {
                            "value": 290,
                            "percent": 25
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 285,
                            "percent": null
                          },
                          "current": {
                            "value": 349,
                            "percent": 22
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 334,
                            "percent": null
                          },
                          "current": {
                            "value": 394,
                            "percent": 18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 384,
                            "percent": null
                          },
                          "current": {
                            "value": 446,
                            "percent": 16
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 423,
                            "percent": null
                          },
                          "current": {
                            "value": 446,
                            "percent": 5
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 473,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 517,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 4,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 10,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 14,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 19,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 23,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 29,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 34,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 40,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 46,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 52,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 2,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 3,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 4,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 5,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 6,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 7,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 8,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 9,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 10,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 2,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 2,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 3,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 3,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 3,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 3,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 3,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 4,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 4,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 87,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 170,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 263,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 347,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 442,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 527,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 594,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 683,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 772,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 821,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 20,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 36,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 44,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 65,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 85,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 90,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 90,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 90,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 98,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 106,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 47,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 96,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 142,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 187,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 236,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 290,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 349,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 394,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 446,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 446,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -43
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 14,
                            "percent": null
                          },
                          "current": {
                            "value": 10,
                            "percent": -28
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 14,
                            "percent": -27
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 27,
                            "percent": null
                          },
                          "current": {
                            "value": 19,
                            "percent": -30
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 35,
                            "percent": null
                          },
                          "current": {
                            "value": 23,
                            "percent": -33
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 41,
                            "percent": null
                          },
                          "current": {
                            "value": 29,
                            "percent": -30
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 47,
                            "percent": null
                          },
                          "current": {
                            "value": 34,
                            "percent": -27
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 55,
                            "percent": null
                          },
                          "current": {
                            "value": 40,
                            "percent": -26
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 61,
                            "percent": null
                          },
                          "current": {
                            "value": 46,
                            "percent": -25
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 65,
                            "percent": null
                          },
                          "current": {
                            "value": 52,
                            "percent": -21
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 72,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 80,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": -23
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": -16
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -9
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 5,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": 6
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": -5
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 7,
                            "percent": -2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 8,
                            "percent": 0
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 10,
                            "percent": null
                          },
                          "current": {
                            "value": 9,
                            "percent": -9
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 11,
                            "percent": null
                          },
                          "current": {
                            "value": 10,
                            "percent": -10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 13,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 14,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": -13
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 29
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 29
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": 29
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 5,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": -36
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 5,
                            "percent": null
                          },
                          "current": {
                            "value": 3,
                            "percent": -36
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 5,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -17
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -44
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 85,
                            "percent": null
                          },
                          "current": {
                            "value": 87,
                            "percent": 2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 171,
                            "percent": null
                          },
                          "current": {
                            "value": 170,
                            "percent": -1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 256,
                            "percent": null
                          },
                          "current": {
                            "value": 263,
                            "percent": 3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 343,
                            "percent": null
                          },
                          "current": {
                            "value": 347,
                            "percent": 1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 428,
                            "percent": null
                          },
                          "current": {
                            "value": 442,
                            "percent": 3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 517,
                            "percent": null
                          },
                          "current": {
                            "value": 527,
                            "percent": 2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 598,
                            "percent": null
                          },
                          "current": {
                            "value": 594,
                            "percent": -1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 678,
                            "percent": null
                          },
                          "current": {
                            "value": 683,
                            "percent": 1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 759,
                            "percent": null
                          },
                          "current": {
                            "value": 772,
                            "percent": 2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 843,
                            "percent": null
                          },
                          "current": {
                            "value": 821,
                            "percent": -3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 926,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 1010,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 20,
                            "percent": 1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 38,
                            "percent": null
                          },
                          "current": {
                            "value": 36,
                            "percent": -6
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 59,
                            "percent": null
                          },
                          "current": {
                            "value": 44,
                            "percent": -26
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 79,
                            "percent": null
                          },
                          "current": {
                            "value": 65,
                            "percent": -18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 100,
                            "percent": null
                          },
                          "current": {
                            "value": 85,
                            "percent": -15
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 120,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": -25
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 141,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": -36
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 162,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": -44
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 177,
                            "percent": null
                          },
                          "current": {
                            "value": 98,
                            "percent": -44
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 198,
                            "percent": null
                          },
                          "current": {
                            "value": 106,
                            "percent": -47
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 219,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 237,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 58,
                            "percent": null
                          },
                          "current": {
                            "value": 47,
                            "percent": -18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 168,
                            "percent": null
                          },
                          "current": {
                            "value": 96,
                            "percent": -43
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 336,
                            "percent": null
                          },
                          "current": {
                            "value": 142,
                            "percent": -58
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 388,
                            "percent": null
                          },
                          "current": {
                            "value": 187,
                            "percent": -52
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 497,
                            "percent": null
                          },
                          "current": {
                            "value": 236,
                            "percent": -52
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 664,
                            "percent": null
                          },
                          "current": {
                            "value": 290,
                            "percent": -56
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 724,
                            "percent": null
                          },
                          "current": {
                            "value": 349,
                            "percent": -52
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 842,
                            "percent": null
                          },
                          "current": {
                            "value": 394,
                            "percent": -53
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 1017,
                            "percent": null
                          },
                          "current": {
                            "value": 446,
                            "percent": -56
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 1059,
                            "percent": null
                          },
                          "current": {
                            "value": 446,
                            "percent": -58
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 1157,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 1293,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": "BGT"
        }
      ],
      "month": [
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -40
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": -24
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -48
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": -41
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -40
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": -18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 5,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": 7
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": 1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 5,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 5,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": 20
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 13
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 81
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 0
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 8
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 47
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -29
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 0
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -32
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 19
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -35
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -98
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 79,
                            "percent": null
                          },
                          "current": {
                            "value": 87,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 80,
                            "percent": null
                          },
                          "current": {
                            "value": 84,
                            "percent": 4
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 79,
                            "percent": null
                          },
                          "current": {
                            "value": 93,
                            "percent": 17
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 82,
                            "percent": null
                          },
                          "current": {
                            "value": 84,
                            "percent": 3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 79,
                            "percent": null
                          },
                          "current": {
                            "value": 95,
                            "percent": 20
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 85,
                            "percent": null
                          },
                          "current": {
                            "value": 85,
                            "percent": 0
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 72,
                            "percent": null
                          },
                          "current": {
                            "value": 67,
                            "percent": -7
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 72,
                            "percent": null
                          },
                          "current": {
                            "value": 89,
                            "percent": 23
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 72,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": 25
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 84,
                            "percent": null
                          },
                          "current": {
                            "value": 49,
                            "percent": -42
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 84,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 84,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 16,
                            "percent": null
                          },
                          "current": {
                            "value": 20,
                            "percent": 24
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 21,
                            "percent": null
                          },
                          "current": {
                            "value": 16,
                            "percent": -22
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 8,
                            "percent": -62
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 18,
                            "percent": null
                          },
                          "current": {
                            "value": 21,
                            "percent": 16
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 20,
                            "percent": 0
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 17,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": -70
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 18,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -99
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 8,
                            "percent": 20
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 16,
                            "percent": null
                          },
                          "current": {
                            "value": 7,
                            "percent": -55
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 19,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 12,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 40,
                            "percent": null
                          },
                          "current": {
                            "value": 47,
                            "percent": 18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 36,
                            "percent": null
                          },
                          "current": {
                            "value": 49,
                            "percent": 36
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 35,
                            "percent": null
                          },
                          "current": {
                            "value": 46,
                            "percent": 32
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 32,
                            "percent": null
                          },
                          "current": {
                            "value": 45,
                            "percent": 44
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 43,
                            "percent": null
                          },
                          "current": {
                            "value": 49,
                            "percent": 14
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 46,
                            "percent": null
                          },
                          "current": {
                            "value": 53,
                            "percent": 16
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 54,
                            "percent": null
                          },
                          "current": {
                            "value": 59,
                            "percent": 10
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 49,
                            "percent": null
                          },
                          "current": {
                            "value": 45,
                            "percent": -8
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 50,
                            "percent": null
                          },
                          "current": {
                            "value": 52,
                            "percent": 3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 38,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 50,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 44,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 4,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 6,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 4,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 5,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 4,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 5,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 6,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 6,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 5,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 6,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 2,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 1,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 87,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 84,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 93,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 84,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 95,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 85,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 67,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 89,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 90,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 49,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 20,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 16,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 8,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 21,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 20,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 5,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 8,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 7,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": null,
                          "current": {
                            "value": 47,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": null,
                          "current": {
                            "value": 49,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": null,
                          "current": {
                            "value": 46,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": null,
                          "current": {
                            "value": 45,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": null,
                          "current": {
                            "value": 49,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": null,
                          "current": {
                            "value": 53,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": null,
                          "current": {
                            "value": 59,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": null,
                          "current": {
                            "value": 45,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": null,
                          "current": {
                            "value": 52,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": null,
                          "current": {
                            "value": 0,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": null,
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -43
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": -8
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -26
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": -37
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 4,
                            "percent": -45
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": -15
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": -2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": -24
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 6,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": -11
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 4,
                            "percent": null
                          },
                          "current": {
                            "value": 6,
                            "percent": 38
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 7,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 8,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MKP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -38
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 2,
                            "percent": 72
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -40
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 22
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 16
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 2,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -50
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": -13
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 1,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Pek. & HiP & Other",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": 1,
                            "percent": 999
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 3,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -99
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 0,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "MAP",
                "subtitle": "Rotem"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 85,
                            "percent": null
                          },
                          "current": {
                            "value": 87,
                            "percent": 2
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 86,
                            "percent": null
                          },
                          "current": {
                            "value": 84,
                            "percent": -3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 85,
                            "percent": null
                          },
                          "current": {
                            "value": 93,
                            "percent": 9
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 87,
                            "percent": null
                          },
                          "current": {
                            "value": 84,
                            "percent": -3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 85,
                            "percent": null
                          },
                          "current": {
                            "value": 95,
                            "percent": 12
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 89,
                            "percent": null
                          },
                          "current": {
                            "value": 85,
                            "percent": -4
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 81,
                            "percent": null
                          },
                          "current": {
                            "value": 67,
                            "percent": -17
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 80,
                            "percent": null
                          },
                          "current": {
                            "value": 89,
                            "percent": 11
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 81,
                            "percent": null
                          },
                          "current": {
                            "value": 90,
                            "percent": 11
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 84,
                            "percent": null
                          },
                          "current": {
                            "value": 49,
                            "percent": -42
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 83,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 84,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Polysulphate",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 20,
                            "percent": 1
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 18,
                            "percent": null
                          },
                          "current": {
                            "value": 16,
                            "percent": -13
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 21,
                            "percent": null
                          },
                          "current": {
                            "value": 8,
                            "percent": -63
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 21,
                            "percent": 6
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 21,
                            "percent": null
                          },
                          "current": {
                            "value": 20,
                            "percent": -3
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": 5,
                            "percent": -74
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 21,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 21,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -99
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 15,
                            "percent": null
                          },
                          "current": {
                            "value": 8,
                            "percent": -46
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 21,
                            "percent": null
                          },
                          "current": {
                            "value": 7,
                            "percent": -65
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 20,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 19,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Potash Plus",
                "subtitle": "Boulby"
              },
              {
                "data": [
                  {
                    "data": {
                      "data": [
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 1,
                          "compare": {
                            "value": 58,
                            "percent": null
                          },
                          "current": {
                            "value": 47,
                            "percent": -18
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 2,
                          "compare": {
                            "value": 52,
                            "percent": null
                          },
                          "current": {
                            "value": 49,
                            "percent": -6
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 3,
                          "compare": {
                            "value": 58,
                            "percent": null
                          },
                          "current": {
                            "value": 46,
                            "percent": -21
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 4,
                          "compare": {
                            "value": 52,
                            "percent": null
                          },
                          "current": {
                            "value": 45,
                            "percent": -13
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 5,
                          "compare": {
                            "value": 58,
                            "percent": null
                          },
                          "current": {
                            "value": 49,
                            "percent": -15
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 6,
                          "compare": {
                            "value": 57,
                            "percent": null
                          },
                          "current": {
                            "value": 53,
                            "percent": -7
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 7,
                          "compare": {
                            "value": 59,
                            "percent": null
                          },
                          "current": {
                            "value": 59,
                            "percent": 0
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 8,
                          "compare": {
                            "value": 59,
                            "percent": null
                          },
                          "current": {
                            "value": 45,
                            "percent": -24
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 9,
                          "compare": {
                            "value": 56,
                            "percent": null
                          },
                          "current": {
                            "value": 52,
                            "percent": -8
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 10,
                          "compare": {
                            "value": 42,
                            "percent": null
                          },
                          "current": {
                            "value": 0,
                            "percent": -100
                          },
                          "partial": null,
                          "isFuture": false,
                          "isDefault": true,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 11,
                          "compare": {
                            "value": 56,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        },
                        {
                          "cif": null,
                          "fob": null,
                          "colName": 12,
                          "compare": {
                            "value": 38,
                            "percent": null
                          },
                          "current": {
                            "value": null,
                            "percent": null
                          },
                          "partial": null,
                          "isFuture": true,
                          "isDefault": false,
                          "colGroupName": null,
                          "isPreliminary": false
                        }
                      ],
                      "columnType": "M"
                    },
                    "title": ""
                  }
                ],
                "title": "Amfert",
                "subtitle": "Amfert"
              }
            ],
            "isMainGraph": false
          },
          "title": "BGT"
        }
      ]
    },
    "type": "GraphNavigation"
  }
}



export const PSGraphsMock = [
    salesPSMock,
    ebitdaPSMock,
    potashDivisionMock,
    oiPSMock
];
